import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'player-age-filter',
    templateUrl: './player-contract-filter.modal.html',
    styleUrls: ['./player-contract-filter.modal.scss'],
})
export class PlayerContractFilterModal implements OnInit {
    
    @Input() freeAgent: boolean;

    @Input() lastYearContract: boolean;

    @Input() nationalSquadPlayer: boolean;

    @Input() schoolBoy: boolean;

    formGroup: FormGroup;

    constructor(public activeModal: NgbActiveModal) {}

    ngOnInit(): void {
        this.formGroup = new FormGroup({
            freeAgentFormControl: new FormControl(false),
            latYearFormControl: new FormControl(false),
            nationalFormControl: new FormControl(false),
            scoolBoyFormControl: new FormControl(false),
            transferFormControl: new FormControl(false),
            rentFormControl: new FormControl(false),
        });
    }

    submit() {
        let result: any = {
            freeAgent: false,
            lastYear: false,
            national: false,
            schoolBoy: false,
            transfer: false,
            rent: false
        }

        if (this.formGroup.controls.freeAgentFormControl.value) {
            result.freeAgent = true;
        }

        if (this.formGroup.controls.latYearFormControl.value) {
            result.lastYear = true;
        }

        if (this.formGroup.controls.nationalFormControl.value) {
            result.national = true;
        }

        if (this.formGroup.controls.scoolBoyFormControl.value) {
            result.schoolBoy = true;
        }

        if (this.formGroup.controls.transferFormControl.value) {
            result.transfer = true;
        }

        if (this.formGroup.controls.rentFormControl.value) {
            result.rent = true;
        }

        this.activeModal.close(result);
    }

    toggleFreeAgent() {
        this.formGroup.controls.freeAgentFormControl.setValue(!this.formGroup.controls.freeAgentFormControl.value);
    }

    toggleLastYear() {
        this.formGroup.controls.latYearFormControl.setValue(!this.formGroup.controls.latYearFormControl.value);
    }

    toggleNational() {
        this.formGroup.controls.nationalFormControl.setValue(!this.formGroup.controls.nationalFormControl.value);
    }

    toggleSchoolBoy() {
        this.formGroup.controls.scoolBoyFormControl.setValue(!this.formGroup.controls.scoolBoyFormControl.value);
    }

    toggleTransfer() {
        this.formGroup.controls.transferFormControl.setValue(!this.formGroup.controls.transferFormControl.value);
    }

    toggleRent() {
        this.formGroup.controls.rentFormControl.setValue(!this.formGroup.controls.rentFormControl.value);
    }
}